import { render, staticRenderFns } from "./LoginComp.vue?vue&type=template&id=6dbe48a5"
import script from "./LoginComp.vue?vue&type=script&lang=js"
export * from "./LoginComp.vue?vue&type=script&lang=js"
import style0 from "./LoginComp.vue?vue&type=style&index=0&id=6dbe48a5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports